import JsonApi from 'devour-client';
import { QuotePayload, QuoteRequest, QuoteResponse } from 'services/interfaces/QuotePayload';
import { ReservationPayload } from 'services/interfaces/ReservationPayload';
import { ServiceBase } from './jsonapi/ServiceBase';

export class ReservationService extends ServiceBase<ReservationPayload> {
  constructor(jsonApi: JsonApi) {
    const schema = ReservationPayload.getSchema();

    super(jsonApi, 'reservation', schema, ReservationPayload);
    super.define('quote', QuotePayload);
  }

  getQuote = async (quote: QuoteRequest) => {
    const raw = QuoteRequest.getRaw(quote);
    let entity = await super.post<QuoteResponse>('quote', raw);
    // Hack when returns 500
    entity = Array.isArray(entity) ? null : entity;
    return entity;
  }
}
